import { ChangeDetectionStrategy, Component, EventEmitter, Output, input } from "@angular/core";

export interface TagOption<T = unknown> {
    value: T;
    label: string;
}

@Component({
    selector: "app-tag",
    templateUrl: "./tag.component.html",
    styleUrl: "./tag.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class TagComponent<T = unknown> {
    /** The tag data to display. */
    option = input.required<TagOption<T>>();

    /** Emits the tag's option when the label is clicked. */
    @Output() clicked = new EventEmitter<TagOption<T>>();
    /** Emits the tag's option when the remove button is clicked. */
    @Output() removed = new EventEmitter<TagOption<T>>();

    onClick(): void {
        this.clicked.emit(this.option());
    }

    onRemove(event: MouseEvent): void {
        event.stopPropagation();
        this.removed.emit(this.option());
    }
}
